import LayoutPasos from "_+_Portal/_-_Autocheckin/components/genericos/LayoutPasos/LayoutPasos";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";
import CruzIcon from "_+_Portal/assets/images/generico/CruzIcon";
import TildeOk from "_+_Portal/assets/images/generico/TildeOk";
import { PortalContext } from "_+_Portal/context/Provider";
import { GlobalContext } from "global/context/Provider";
import { useContext, useEffect, useState } from "react";
import { ContainerNumeroAfiliado } from "./localStyle";
import { setIdTipoPuntoControl } from "_+_Portal/_-_Autocheckin/context/action/puntoControl";
import { getLocalStorage } from "global/utils/safeJsonParse";
import { hideModal } from "_+_Portal/context/Actions/modal/modal";

const NumeroAfiliado = ({ turnoActual, setLoading }) => {
  // -------------------------  context ----------------------------
  const {
    pasoDispatch,
    pasoState,
    turnosSeleccionadosState,
    puntoControlDispatch,
  } = useContext(AutocheckContext);
  const { authState } = useContext(GlobalContext);
  const { selectDropDownState } = useContext(PortalContext);

  const [nroAfiliado, setNroAfiliado] = useState("");
  // -------------------------  context ----------------------------

  // -------------------------  constants ----------------------------
  const paciente = selectDropDownState.selectDropDown.selectGlobal
    .pacienteElegido
    ? selectDropDownState.selectDropDown.selectGlobal.pacienteElegido.paciente
    : authState.auth?.data?.paciente;
  const cobertura = paciente?.cobertura;
  const isParticular = cobertura?.idCobertura === "PART";
  const listTurnosSeleccionado =
    turnosSeleccionadosState.turnosSeleccionados?.data ?? [];
  const turno = listTurnosSeleccionado && listTurnosSeleccionado[turnoActual];
  const nroAfiliadoExist =
    cobertura?.afiliado?.length > 1 || turno?.nro_afiliado;
  let idTerminal = getLocalStorage("idTerminal");
  // -------------------------  constants ----------------------------

  // -------------------------  funtion ----------------------------
  const success = () => {
    if (pasoState.circuito === "labo") {
      setPaso("ResumenLabo")(pasoDispatch);
    } else {
      if (turno) {
        setPaso("Resumen")(pasoDispatch);
      } else {
        setPaso("AgendasDisponibles")(pasoDispatch);
      }
    }
  };

  const fail = () => {
    // setTurnosSeleccionado(turno)(turnosSeleccionadosDispatch);
    const idTipoPuntoControl = 3;
    setIdTipoPuntoControl(idTipoPuntoControl)(puntoControlDispatch);
    setPaso("PuntoControl")(pasoDispatch);
  };

  const changeInput = (e) => {
    const value = e.target.value;
    setNroAfiliado(value);
  };

  // Manda a PuntoControl solo si:
  // - Ya tenemos los datos de cobertura (evita falso positivo por datos async).
  // - El paciente NO es particular (particular no necesita nro de afiliado).
  // - No tiene nro de afiliado cargado.
  useEffect(() => {
    if (!cobertura) return;
    if (isParticular) return;
    if (!nroAfiliadoExist) {
      setIdTipoPuntoControl(3)(puntoControlDispatch);
      setPaso("PuntoControl")(pasoDispatch);
    }
  }, [
    cobertura,
    isParticular,
    nroAfiliadoExist,
    puntoControlDispatch,
    pasoDispatch,
  ]);

  // -------------------------  funtion ----------------------------

  return (
    <LayoutPasos
      volverTo={"/autocheckin"}
      handleClick={() => {
        turno
          ? setPaso("TurnosDelDia")(pasoDispatch)
          : setPaso("Home")(pasoDispatch);
      }}
      type={"no-circle"}
      title={"VERIFICACIÓN DE DATOS"}
    >
      <ContainerNumeroAfiliado
        initial={{ opacity: 0, y: -90 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 100 }}
        transition={{ duration: 0.4 }}
        $isTerminal={idTerminal}
      >
        <div className="content">
          <span>
            Antes de iniciar el proceso de recepción le pedimos que{" "}
            <span className="bold">
              verifique la información sobre su cobertura médica
            </span>{" "}
            a continuación:
          </span>
          <span>
            Obra Social: <span className="bold">{cobertura?.cobertura}</span>
          </span>
          <span>
            Plan: <span className="bold">{cobertura?.plan}</span>
          </span>
          <span>
            {!isParticular && "Número de Afiliado:"}
            {!nroAfiliadoExist && !isParticular ? (
              <input
                onChange={changeInput}
                className="nroAfiliado-input"
                type="number"
                placeholder="Ej: 12321343"
                value={nroAfiliado}
              />
            ) : (
              <span className="bold">
                {" "}
                {cobertura?.afiliado ? cobertura.afiliado : turno?.nro_afiliado}
              </span>
            )}
          </span>
          {nroAfiliadoExist && <span>¿Son los datos correctos?</span>}
          <div className="container-btn">
            <button className="bgc-danger c-white btnAfiliado" onClick={fail}>
              <CruzIcon
                width={"15"}
                height={"15"}
                color={"var(--color-white)"}
              />{" "}
              No
            </button>
            <button
              className="bgc-broccoli c-white btnAfiliado"
              onClick={success}
            >
              <TildeOk
                width={"15"}
                height={"15"}
                color={"var(--color-white)"}
              />{" "}
              Si
            </button>
          </div>
        </div>
      </ContainerNumeroAfiliado>
    </LayoutPasos>
  );
};
export default NumeroAfiliado;
